var EventsContainer;
(function (EventsContainer) {
    document.addEventListener('ControllerReady', function () {
        const config = retrieveConfiguration(document);
        const ServicesEndpoint = `/api/events-filter`;
        const containerDetailsEndpoint = `/api/esb/eventLocator/containerDetail?_format=form`;
        const $dealsContainer = document.querySelector('.wrapper-services-events');
        const item_per_page = 6;
        let containerArray = [];
        const monthNames = [
            'Gennaio',
            'Febbraio',
            'Marzo',
            'Aprile',
            'Maggio',
            'Giugno',
            'Luglio',
            'Agosto',
            'Settembre',
            'Ottobre',
            'Novembre',
            'Dicembre',
        ];
        function setCookie(cname, cvalue) {
            document.cookie =
                cname + '=' + encodeURIComponent(cvalue) + ';domain=' + window.location.hostname + ';path=/;secure;';
        }
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        function deleteCookie(name) {
            if (getCookie(name) != '') {
                document.cookie =
                    name +
                        '=' +
                        ';domain=' +
                        window.location.hostname +
                        ';path=/' +
                        ';secure' +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
        function retrieveConfiguration($wrapper) {
            let data = {};
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        if ($dealsContainer) {
            let $carousel = document.querySelector('.train-card');
            let config;
            let filters = new Map();
            function retrieveConfig($wrapper) {
                let data = {};
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function init() {
                sendrequest();
            }
            function isMobile() {
                return window.innerWidth <= 900;
            }
            function sendrequest() {
                const eventContainers = document.querySelectorAll('.events-container');
                eventContainers.forEach((eventContainer) => {
                    let containerCard = eventContainer.querySelector('#cards-container');
                    eventContainer.setAttribute('data-spinner', 'mask');
                    let tipologia = eventContainer.querySelector('#tipo_evento').value;
                    let cooperativa = eventContainer.querySelector('#cooperativa').value;
                    var jsonParts = [];
                    if (tipologia !== "") {
                        jsonParts.push('"tipologia_desc": "' + tipologia + '"');
                    }
                    if (cooperativa !== "") {
                        jsonParts.push('"cooperative_desc": "' + cooperativa + '"');
                    }
                    var myJsonFilterString = '{' + jsonParts.join(',') + '}';
                    const tot_cards = eventContainer
                        .querySelector('#cards-container')
                        .querySelectorAll('.type-3').length;
                    const tot_containers = eventContainer
                        .querySelector('#cards-container')
                        .querySelectorAll('.type-3.container-event').length > 0
                        ? eventContainer
                            .querySelector('#cards-container')
                            .querySelectorAll('.type-3.container-event').length
                        : 0;
                    const tot_events = eventContainer.querySelectorAll('.single-event');
                    let last_event = '0';
                    if (tot_events.length > 0)
                        last_event = eventContainer
                            .querySelectorAll('.single-event')[tot_events.length - 1].getAttribute('id');
                    Fetch(ServicesEndpoint, {
                        method: 'POST',
                        data: {
                            filters: myJsonFilterString,
                            item_showed: last_event,
                            comtainer_showed: tot_containers,
                            load_more: false,
                        },
                        token: {
                            enable: true,
                        },
                    })
                        .then((response) => {
                        let resp = response['data'];
                        if (resp.header.status == 'OK') {
                            var eventi_filtrati = resp.body.events;
                            containerCard.innerHTML = '';
                            containerArray = [];
                            var i = 0;
                            if (eventi_filtrati.length == 0)
                                document.querySelector('.no-results').style.display = 'flex';
                            for (i = 0; i < eventi_filtrati.length; i++) {
                                if (eventi_filtrati[i].container != null) {
                                    console.log('OK');
                                    createContainerCard(eventi_filtrati[i], containerCard);
                                }
                                else {
                                    createEventCard(eventi_filtrati[i], containerCard);
                                }
                            }
                            $carousel = document.querySelector('.train-card');
                            trigger(document, 'init-train-card', $carousel);
                        }
                        else {
                            console.log('Errore nella chiamata del servizio: ' + ServicesEndpoint);
                        }
                        eventContainer.removeAttribute('data-spinner');
                    })
                        .catch((err) => {
                        console.error('Error: ', err);
                        eventContainer.removeAttribute('data-spinner');
                    });
                });
            }
            function createEventCard(element, containerCard) {
                var dummy = document.querySelector('#card_dummy');
                var filter_card = dummy.cloneNode(true);
                var copertina = null;
                var arrayImage = new Array();
                if (isMobile() && element.imagesMobile.length > 1) {
                    arrayImage = element.imagesMobile;
                }
                else {
                    arrayImage = element.images;
                }
                for (let i = 0; i < arrayImage.length; i++) {
                    if (arrayImage[i]['main'] == 1) {
                        copertina = arrayImage[i];
                        break;
                    }
                }
                filter_card.querySelector('#img_filter_card').src =
                    copertina.image;
                filter_card.querySelector('.title').innerHTML = element.title;
                filter_card.querySelector('.category').innerHTML = generateCategoryString(element.category);
                filter_card === null || filter_card === void 0 ? void 0 : filter_card.addEventListener('click', function () {
                    window.location.href =
                        '/eventi/' +
                            element.id +
                            '/' +
                            element.title.replace(/[^a-zA-Z0-9\s\-_]/gim, '').replace(/\s/gim, '-');
                });
                if (element.onlyMembers == 0) {
                    filter_card.querySelector('.socio').setAttribute('disabled', '');
                }
                var badgeCssClass = getBadge(element.status.id);
                filter_card.querySelector('.status-badge').innerHTML = element.status.description;
                filter_card.querySelector('.status-badge').classList.add(badgeCssClass);
                var parts = element.eventStartDate.split('-');
                var eventDtStart = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                var eventDtEnd = null;
                if (element.eventEndDate != null) {
                    parts = element.eventEndDate.split('-');
                    eventDtEnd = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                }
                var locale = 'it-it';
                var monthEnd = null;
                var monthStart = eventDtStart.toLocaleString(locale, { month: 'long' });
                if (eventDtEnd != null) {
                    monthEnd = eventDtEnd.toLocaleString(locale, { month: 'long' });
                }
                let str_data = 'Data: <b>';
                if (element.eventEndDate == null) {
                    str_data +=
                        eventDtStart.getDate() +
                            ' ' +
                            monthStart[0].toUpperCase() +
                            monthStart.slice(1);
                }
                else if (element.eventStartDate == element.eventEndDate) {
                    str_data +=
                        eventDtStart.getDate() +
                            ' ' +
                            monthStart[0].toUpperCase() +
                            monthStart.slice(1);
                }
                else {
                    str_data +=
                        eventDtStart.getDate() +
                            ' ' +
                            monthStart[0].toUpperCase() +
                            monthStart.slice(1) +
                            '</b> - <b>' +
                            eventDtEnd.getDate() +
                            ' ' +
                            monthEnd[0].toUpperCase() +
                            monthEnd.slice(1);
                }
                str_data += '</b> Ore: <b>';
                if (element.eventStartHour == element.eventEndHour ||
                    element.eventEndHour == null) {
                    let split = element.eventStartHour.split(':');
                    if (split[1] == '00') {
                        str_data += split[0];
                    }
                    else {
                        str_data += element.eventStartHour;
                    }
                }
                else {
                    let splitStart = element.eventStartHour.split(':');
                    let splitEnd = element.eventEndHour.split(':');
                    if (splitStart[1] != '00' || splitEnd[1] != '00') {
                        str_data += element.eventStartHour + ' - ' + element.eventEndHour;
                    }
                    else {
                        str_data += splitStart[0] + ' - ' + splitEnd[0];
                    }
                }
                str_data += '</b>';
                filter_card.querySelector('.due-date').innerHTML = str_data;
                filter_card.querySelector('.description').innerHTML = element.description;
                filter_card.querySelector('.positionClass').innerHTML =
                    element.places[0].name +
                        '<br>' +
                        element.places[0].address +
                        ', ' +
                        element.places[0].city +
                        ' ' +
                        (element.places[0].zipcode ? ' ' + element.places[0].zipcode : '');
                if (element.onlyMembers == 1) {
                    filter_card.querySelector('#bollino-socio').style.display =
                        'inline-block';
                }
                var div_associata = filter_card.querySelector('#coop_associata');
                var temp_a = filter_card.querySelector('.cp-link');
                for (let j = 0; j < element.cooperative.length; j++) {
                    var cooperativa_a = temp_a.cloneNode(true);
                    cooperativa_a.innerHTML = element.cooperative[j].description;
                    var linkToPage = getLink(element.cooperative[j].id);
                    cooperativa_a.setAttribute('href', linkToPage);
                    cooperativa_a.classList.remove('hidden');
                    temp_a.appendChild(cooperativa_a);
                }
                filter_card.classList.remove('dummy');
                filter_card.id = element.id;
                filter_card.classList.add('single-event');
                containerCard === null || containerCard === void 0 ? void 0 : containerCard.appendChild(filter_card);
            }
            function createContainerCard(element, containerCard) {
                if (!containerArray.includes(element.container.id)) {
                    containerArray.push(element.container.id);
                    let container = getContainerDetails(element, containerCard);
                }
            }
            function generateCategoryString(array) {
                var result = '';
                for (var i = 0; i < array.length; i++) {
                    result += '#' + array[i].description + ' ';
                }
                return result;
            }
            function getLink(coopId) {
                switch (coopId) {
                    case '1':
                        return 'https://www.coop.it/cooperative/coop-nova/home-nc';
                    case '2':
                        return 'https://www.coop.it/cooperative/coop-liguria/home';
                    case '3':
                        return 'https://www.coop.it/cooperative/coop-lombardia/homepage';
                    case '7':
                        return 'https://www.coopfirenze.it/';
                    case '8':
                        return 'https://www.unicooptirreno.it/';
                    case '9':
                        return 'https://www.coopcentroitalia.it/';
                    case '35':
                        return 'https://www.coopalleanza3-0.it/';
                    default:
                        return '';
                }
            }
            function calculateJsonFromMap(map) {
                let jsonObject = {};
                map.forEach((value, key) => {
                    jsonObject[key] = value;
                });
                return JSON.stringify(jsonObject);
            }
            function isSubscribed(eventId) {
                return false;
            }
            function getContainerDetails(element, containerCard) {
                var url = {
                    idContainer: element.container.id,
                };
                Fetch(containerDetailsEndpoint, {
                    method: 'POST',
                    data: url,
                    token: {
                        enable: true,
                    },
                })
                    .then((response) => {
                    if (response.header.result == 'OK') {
                        let container = response.payload.container;
                        if (container != null) {
                            var dummy = document.querySelector('#container_dummy');
                            var filter_card = dummy.cloneNode(true);
                            var copertina = null;
                            var arrayImage = new Array();
                            if (isMobile() && container.imagesMobile.length > 1) {
                                arrayImage = container.imagesMobile;
                            }
                            else {
                                arrayImage = container.images;
                            }
                            for (let i = 0; i < arrayImage.length; i++) {
                                if (arrayImage[i]['main'] == 1) {
                                    copertina = arrayImage[i];
                                    break;
                                }
                            }
                            filter_card.querySelector('#img_filter_card').src = copertina.image;
                            filter_card.querySelector('.title').innerHTML = container.title;
                            filter_card.querySelector('.category').innerHTML = container.tag;
                            filter_card === null || filter_card === void 0 ? void 0 : filter_card.addEventListener('click', function () {
                                window.location.href =
                                    '/eventi/' +
                                        container.id +
                                        '/' +
                                        container.title
                                            .replace(/[^a-zA-Z0-9\s\-_]/gim, '')
                                            .replace(/\s/gim, '-') +
                                        '?container=true';
                            });
                            var parts = container.startDate.split('-');
                            var eventDtStart = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                            var eventDtEnd;
                            if (container.endDate != null) {
                                parts = container.endDate.split('-');
                                eventDtEnd = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                            }
                            let str_data = '';
                            let locale = 'it-it';
                            if (eventDtEnd == null || eventDtStart == eventDtEnd) {
                                str_data += formatDateEvents(eventDtStart, eventDtEnd, container.events);
                            }
                            else if (eventDtStart.toLocaleString(locale, { month: 'long' }) !=
                                eventDtEnd.toLocaleString(locale, { month: 'long' })) {
                                str_data += formatDateRange(eventDtStart, eventDtEnd, true);
                            }
                            else {
                                str_data += formatDateRange(eventDtStart, eventDtEnd, false);
                            }
                            filter_card.querySelector('.due-date').innerHTML = str_data;
                            filter_card.querySelector('.description').innerHTML =
                                container.description;
                            if (element.onlyMembers == 1) {
                                filter_card.querySelector('#bollino-socio').style.display = 'inline-block';
                            }
                            filter_card.classList.remove('dummy');
                            filter_card.id = container.id;
                            filter_card.classList.add('container-event');
                            containerCard.appendChild(filter_card);
                        }
                    }
                    else {
                        return '';
                    }
                })
                    .catch((err) => {
                });
            }
            function formatDateRange(start, end, bool) {
                const startMonth = monthNames[start.getMonth()];
                const endMonth = monthNames[end.getMonth()];
                if (bool) {
                    return `Dal ${start.getDate()} ${startMonth} ${start.getFullYear()} al ${end.getDate()} ${endMonth} ${end.getFullYear()}`;
                }
                else {
                    return `Dal ${start.getDate()} al ${end.getDate()} ${startMonth} ${end.getFullYear()}`;
                }
            }
            function formatDateEvents(start, end, events) {
                if (!start || !events)
                    return '';
                const startDate = new Date(start);
                const endDate = end ? new Date(end) : null;
                const monthNames = [
                    "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
                    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
                ];
                const getMonthName = (date) => monthNames[date.getMonth()];
                const isSameDay = (d1, d2) => d1.getDate() === d2.getDate() &&
                    d1.getMonth() === d2.getMonth() &&
                    d1.getFullYear() === d2.getFullYear();
                const isDifferentMonth = (d1, d2) => d1.getMonth() !== d2.getMonth() ||
                    d1.getFullYear() !== d2.getFullYear();
                if (endDate && isSameDay(startDate, endDate)) {
                    let orari = '';
                    events.forEach((event, index) => {
                        if (events.length > 2) {
                            orari += event.eventStartHour + (index < events.length - 1 ? ' - ' : '');
                        }
                        else if (events.length === 1) {
                            orari += event.eventStartHour;
                        }
                        else {
                            orari += event.eventStartHour + (index === 0 ? ' e ' : '');
                        }
                    });
                    return `Data: ${startDate.getDate()} ${getMonthName(startDate)} ${startDate.getFullYear()} Ore: ${orari}`;
                }
                if (!endDate) {
                    return `Dal ${startDate.getDate()} ${getMonthName(startDate)} ${startDate.getFullYear()}`;
                }
                if (isDifferentMonth(startDate, endDate)) {
                    return `Dal ${startDate.getDate()} ${getMonthName(startDate)} ${startDate.getFullYear()} al ${endDate.getDate()} ${getMonthName(endDate)} ${endDate.getFullYear()}`;
                }
                return `Dal ${startDate.getDate()} al ${endDate.getDate()} ${getMonthName(endDate)} ${endDate.getFullYear()}`;
            }
            function getBadge(statusId) {
                const statusMap = {
                    1: 'success',
                    2: 'warning',
                    3: 'danger',
                    4: 'danger',
                    5: 'warning',
                    6: 'danger',
                    7: 'danger',
                    8: 'warning' 
                };
                const cssClass = statusMap[statusId] || 'warning';
                return cssClass;
            }
            init();
        }
    });
})(EventsContainer || (EventsContainer = {}));
